import { css } from '@emotion/css/macro';
import SwiperView from './SwiperView';
import * as React from 'react';
import StyleConstants from '../../../../common/StyleConstants';

const style = css`
  max-width: ${StyleConstants.MAX_WIDTH}px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #e7ecf8;
  padding: 40px 0 80px;
  h2 {
    color: #42607f;
    font-size: 22px;
    font-weight: bold;
    line-height: 1.36;
    letter-spacing: -0.82px;
  }
`;
const title = css`
  display: flex;
  flex-direction: row;
`;
const divider = css`
  height: 2px;
  width: 78px;
  background-color: #42607f;
  margin: 14px 4px;
`;
const dotGroup = css`
  display: flex;
  flex-direction: row;
`;
const dot = css`
  width: 12px;
  height: 12px;
  border-radius: 24px;
  margin: 4.5px;
`;
const previewWarpper = css`
  max-width: ${StyleConstants.MAX_WIDTH}px;
`;
export default function PreviewView() {
  const [view, setView] = React.useState(1);
  return (
    <section className={style}>
      <div className={title} id='preview'>
        <div className={divider}></div>
        <h2>도깃 이용방법</h2>
        <div className={divider}></div>
      </div>
      <h2>미리 엿보기👁👁</h2>
      <div className={previewWarpper}>
        <SwiperView setView={setView} />
      </div>
      <div className={dotGroup}>
        {Array(4)
          .fill('')
          .map((el, idx) => (
            <div className={dot} key={idx} style={{ backgroundColor: idx + 1 === view ? '#f48c95' : '#b9c3ca' }}></div>
          ))}
      </div>
    </section>
  );
}
